<template>
  <v-app>
    <message/>
    <router-view/>
  </v-app>

</template>

<script>
import {config} from '~/plugins/config'
import Message from '~/components/Message'

export default {
  name: 'ExternalGameLayout',

  components: {Message},

}
</script>
